var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { msg, localized } from '@lit/localize';
import '../text/SqlCodeDisplayer';
let SqlCodeInput = class SqlCodeInput extends LitElement {
    constructor() {
        super(...arguments);
        this.code = '';
    }
    onInput(e) {
        this.code = e.target.value;
        this.dispatchEvent(new CustomEvent('code-changed', { detail: this.code }));
    }
    render() {
        return html `
      <textarea
        .value=${this.code}
        @input=${this.onInput}
        placeholder=${msg('Write SQL code here...', { id: 'form.sql.placeholder', desc: 'SQL code textarea placeholder' })}
      ></textarea>
      <sql-code-displayer .code=${this.code}></sql-code-displayer>
    `;
    }
};
SqlCodeInput.styles = css `
    :host {
      display: block;
    }
    textarea {
      width: 100%;
      min-height: 120px;
      font-family: 'Fira Code', monospace;
      font-size: 1em;
      margin-bottom: 1em;
      box-sizing: border-box;
    }
  `;
__decorate([
    property({ type: String })
], SqlCodeInput.prototype, "code", void 0);
SqlCodeInput = __decorate([
    localized(),
    customElement('sql-code-input')
], SqlCodeInput);
export { SqlCodeInput };
//# sourceMappingURL=SqlCodeInput.js.map